import React from "react";
import { FaEnvelope, FaFacebook, FaPhoneAlt } from "react-icons/fa";

function SiteFooter({ bookingHref, phoneNumber }) {
  return (
    <footer>
      <div className="contact-info">
        <a href={bookingHref} className="phone-link">
          <FaPhoneAlt />
          <span>{phoneNumber}</span>
        </a>
        <a
          href="mailto:bookings@nomii.restaurant"
          className="email-link booking-email"
        >
          <FaEnvelope />
          <span className="contact-copy">
            <span className="contact-label">Booking enquiries</span>
            <span className="email-address">
              bookings@nomii.restaurant
            </span>
          </span>
        </a>
        <a
          href="mailto:hello@nomii.restaurant"
          className="email-link manager-email"
        >
          <FaEnvelope />
          <span className="contact-copy">
            <span className="contact-label">Other enquiries</span>
            <span className="email-address">hello@nomii.restaurant</span>
          </span>
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61572395491144"
          className="social-link"
          aria-label="Facebook"
        >
          <FaFacebook />
          <span>Follow us</span>
        </a>
      </div>
      <p className="copyright">
        &copy; {new Date().getFullYear()} nomii Thai Asian Dining
      </p>
    </footer>
  );
}

export default SiteFooter;
